// Pure helpers for the access codes queue screen (containers/Queues).

export const QUEUE_VIEWS = {
  OPEN: 'open',
  PENDING: 'pending',
  CLOSED: 'closed',
  ALL: '__none__',
};

export const DEFAULT_QUEUE_VIEW = QUEUE_VIEWS.OPEN;

// Values stay strings: removeEmptyQs (api/index.js) drops a numeric 0.
const VIEW_PARAMS = {
  [QUEUE_VIEWS.OPEN]: { status: 'open' },
  [QUEUE_VIEWS.PENDING]: { pending: '1' },
  [QUEUE_VIEWS.CLOSED]: { pending: '0' },
  [QUEUE_VIEWS.ALL]: {},
};

/**
 * Translates the "Situation" select value into the query params expected by
 * GET /api/admin/queues. Unknown values fall back to no filter.
 */
export const toQueueListParams = view => ({ ...(VIEW_PARAMS[view] || {}) });

/**
 * Builds the list query from the screen filters. `view` is a UI-only field and
 * never reaches the API (the backend would treat it as an unknown column).
 */
export const buildQueueListQuery = ({ view, ...filters } = {}) => ({
  ...filters,
  ...toQueueListParams(view),
});

const STATUS_LABEL_IDS = {
  RETRYING: 'Queue status retrying',
  EXHAUSTED: 'Queue status exhausted',
  CLOSED: 'Queue status closed',
  EXPIRED: 'Queue status expired',
};

/**
 * i18n message id for a backend `queue_status`, or null when the status is
 * missing or unknown (e.g. an older backend).
 */
export const queueStatusLabelId = status => STATUS_LABEL_IDS[status] || null;

const RETRY_ERROR_IDS = {
  NOT_FOUND: 'Queue record not found',
  QUEUE_RECORD_EXPIRED: 'Queue record expired, nothing left to deliver',
  QUEUE_RECORD_NOT_RETRYABLE: 'Queue record is still being retried',
  INVITATION_ALREADY_QUEUED:
    'Invitation already has a queue record in progress',
  QUEUE_RECORD_BUSY: 'Queue record is being processed, try again in a moment',
};

/**
 * i18n message id for a known retry error code, or null for anything else
 * (the generic api error toast is kept in that case).
 */
export const retryErrorMessageId = code => RETRY_ERROR_IDS[code] || null;
